import { TrackDisplayCoreObject } from '@core_n/asp/TrackDisplayCoreObject';
import { AspObject } from '@core_n/asp/AspObject';
import { IObjectsDrawer } from '@core_n/asp/interfaces';
import { IP_HIST_COUNT as IP_HIST_COUNT, TrackObject, TrackIp, TrackThreat } from './TrackObject';
import { settings } from 'cluster';
import { userSettings } from '@core_n/common/settings';
import * as utils from '@core_n/common/utils';
import * as enums from '@core_n/common/enums';
import { IfStmt, rendererTypeName } from '@angular/compiler';
import { elementEventFullName } from '@angular/compiler/src/view_compiler/view_compiler';
import { colorOfIdentity } from '@core_n/asp/aspSettings';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import * as aspSettings from '../../core/app/asp/aspSettings';

export enum TrackDataType {
  IpPoly = 'ipPoly',
  IpLine = 'ipLine',
  Threat = 'Threat'
}
var HOOKED_COLOR = [1, 1, 1, 1]; // red

var IP_COLOR = [1, 0, 0, 1]; // red
var IP_COLOR_SMT = [1, 0, 0, 1]; // red
var IP_OPACITY = 0.2;

var TP_COLOR = [1, 0, 0, 1]; // red
var TP_COLOR_SMT = [1, 0, 0, 1]; // red
var TP_OPACITY = 0.2;

var lineWidth = 2;

export class TrackDisplayObject extends TrackDisplayCoreObject {

  private prevIsDuplicated: boolean;

  constructor(aspObject: AspObject, drawer: IObjectsDrawer) {
    super(aspObject, drawer);

    if (userSettings.userPerm == enums.Permission.ADMIN) {
      IP_COLOR = utils.cssColorToNewmi(userSettings.IpTrackColor);
      IP_COLOR_SMT = utils.cssColorToNewmi(userSettings.IpTrackColorSmt);
      TP_COLOR = utils.cssColorToNewmi(userSettings.TpTrackColor);
      TP_COLOR_SMT = utils.cssColorToNewmi(userSettings.TpTrackColorSmt);
    }

    // newmi-tbd
    this.drawData[TrackDataType.IpPoly] = null;
    this.drawData[TrackDataType.IpLine] = null;
    this.drawData[TrackDataType.Threat] = null;
    // for (let i = 0; i < IP_HIST_COUNT; i++) {
    //   this.drawData[TrackDataType.IpPoly + i] = null;
    //   this.drawData[TrackDataType.IpLine + i] = null;
    // }
  }

  // Override DisplayObject
  onDataChange(update?: boolean): void {
    let trackObject = this.aspObject as TrackObject;

    this.colorChanged = this.colorChanged || typeof this.prevIsDuplicated == 'undefined' || this.prevIsDuplicated != trackObject.isDuplicated;

    super.onDataChange();

    // newmi-tbd
    this.handleIp(trackObject.ip, update);
    this.handleThreat(trackObject.threatPoly, update);
  }

  prepareToDraw() {
    let trackObject = this.aspObject as TrackObject;

    if (userSettings.userPerm == enums.Permission.ADMIN) {
      let color = utils.cssColorToNewmi(userSettings.IpTrackColor);
      if (IP_COLOR.toString() != color.toString())
        IP_COLOR = utils.cssColorToNewmi(userSettings.IpTrackColor);
      trackObject.ForceUpdate = true;

      color = utils.cssColorToNewmi(userSettings.IpTrackColorSmt);
      if (IP_COLOR_SMT.toString() != color.toString())
        IP_COLOR_SMT = utils.cssColorToNewmi(userSettings.IpTrackColorSmt);
      trackObject.ForceUpdate = true;

      color = utils.cssColorToNewmi(userSettings.TpTrackColor);
      if (TP_COLOR.toString() != color.toString())
        TP_COLOR = utils.cssColorToNewmi(userSettings.TpTrackColor);
      trackObject.ForceUpdate = true;

      color = utils.cssColorToNewmi(userSettings.TpTrackColorSmt);
      if (TP_COLOR_SMT.toString() != color.toString())
        TP_COLOR_SMT = utils.cssColorToNewmi(userSettings.TpTrackColorSmt);
      trackObject.ForceUpdate = true;
    }
    else {
      IP_COLOR = [1, 0, 0, 1];
      IP_COLOR_SMT = [1, 0, 0, 1];
      TP_COLOR = [1, 0, 0, 1];
      TP_COLOR_SMT = [1, 0, 0, 1];
    }

    if (IP_OPACITY != userSettings.IpFillOpacity) {
      IP_OPACITY = userSettings.IpFillOpacity;
      trackObject.ForceUpdate = true;
    }

    if (TP_OPACITY != userSettings.TpFillOpacity) {
      TP_OPACITY = userSettings.TpFillOpacity;
      trackObject.ForceUpdate = true;
    }
    // do the same as color but for opacity

    this.onDataChange(true);

    super.prepareToDraw();
  }

  private handleIp(Ip: TrackIp, update?: boolean) {
    let trackObject = this.aspObject as TrackObject;
    if (Ip == null || (userSettings.userPerm == enums.Permission.USER && !trackObject.sentToSmart)) {
      this.drawData[TrackDataType.IpPoly] = null;
      this.drawData[TrackDataType.IpLine] = null
      // this.drawer.updateObjectInDm(this);
      return;
    }
    let fillcolor = [];
    let color = [];

    if (trackObject.ip && userSettings.userPerm == enums.Permission.ADMIN) {
      if (aspSettings.selectedIds.has(trackObject.id)) {
        fillcolor = [HOOKED_COLOR[0], HOOKED_COLOR[1], HOOKED_COLOR[2], IP_OPACITY];
        color = HOOKED_COLOR;
      }
      else {
        if (trackObject.sentToSmart) {
          fillcolor = [IP_COLOR_SMT[0], IP_COLOR_SMT[1], IP_COLOR_SMT[2], IP_OPACITY];
          color = IP_COLOR_SMT;
        } else {
          fillcolor = [IP_COLOR[0], IP_COLOR[1], IP_COLOR[2], IP_OPACITY];
          color = IP_COLOR;
        }
      }
    }
    else {
      fillcolor = [IP_COLOR[0], IP_COLOR[1], IP_COLOR[2], IP_OPACITY];
      color = IP_COLOR;
    }

    let added = false;
    if (Ip && Ip.polySet) {
      if (!this.drawData[TrackDataType.IpLine] && userSettings.userPerm == enums.Permission.ADMIN) {
        this.drawData[TrackDataType.IpLine] = this.createGeometryDrawData(Ip.line, lineWidth, color);
        added = true;
      }
      if (!this.drawData[TrackDataType.IpPoly]) {
        this.drawData[TrackDataType.IpPoly] = this.createGeometryDrawData(Ip.poly, lineWidth, color, fillcolor);
        added = true;
      }

      if (update) {
        if (userSettings.userPerm == enums.Permission.ADMIN)
          this.drawData[TrackDataType.IpLine] = this.createGeometryDrawData(Ip.line, lineWidth, color);
        this.drawData[TrackDataType.IpPoly] = this.createGeometryDrawData(Ip.poly, lineWidth, color, fillcolor);
        this.drawer.updateObjectInDm(this);
      }

      if (added && this.isVisible()) {
        // this.drawer.addObjectToDm(this, [TrackDataType.IpLine], [TrackDataType.IpLine]);
        if (userSettings.userPerm == enums.Permission.ADMIN)
          this.drawer.addObjectToDm(this, [TrackDataType.IpLine, TrackDataType.IpPoly], [TrackDataType.IpLine, TrackDataType.IpPoly]);
        else
          this.drawer.addObjectToDm(this, [TrackDataType.IpPoly], [TrackDataType.IpPoly]);
      }

      // !!! i need to recreate this section if i want to support history

      // for (let i = 0; i < lpIp.prevPolys.length; i++) {
      //   added = false;
      //   //Line
      //   if (!this.drawData[TrackDataType.IpLine + i]) {
      //     let fadeColor = [...color];
      //     fadeColor[3] = 0.8 - (i / LP_IP_HIST_COUNT) * 0.7;
      //     this.drawData[TrackDataType.IpLine + i] = this.createGeometryDrawData(lpIp.prevPolys[i], lineWidth, fadeColor);
      //     added = true;
      //   }
      //   if (!this.drawData[dataType + i]) {
      //     let fadeColor = [...color];
      //     fadeColor[3] = 0.8 - (i / LP_IP_HIST_COUNT) * 0.7;
      //     this.drawData[dataType + i] = this.createGeometryDrawData(lpIp.prevPolys[i], lineWidth, fadeColor, fadeColor);
      //     added = true;
      //   }
      //   if (this.drawer.is3D())
      //     this.drawData[dataType + i].location = lpIp.prevPolys[i];
      //   else
      //     this.drawData[dataType + i].geometry = lpIp.prevPolys[i];
      //   if (added && this.isVisible())
      //     this.drawer.addObjectToDm(this, [dataType + i], [dataType + i]);
      // }
    }
  }

  private handleThreat(threat: TrackThreat, update?: boolean) {
    let trackObject = this.aspObject as TrackObject;

    if (threat == null || (userSettings.userPerm == enums.Permission.USER && !trackObject.sentToSmart)) {
      this.drawData[TrackDataType.Threat] = null;
      // this.drawer.updateObjectInDm(this);
      return;
    }

    let fillcolor = [];
    let color = [];
    if (trackObject.threatPoly && userSettings.userPerm == enums.Permission.ADMIN) {
      if (aspSettings.selectedIds.has(trackObject.id)) {
        fillcolor = [HOOKED_COLOR[0], HOOKED_COLOR[1], HOOKED_COLOR[2], IP_OPACITY];
        color = HOOKED_COLOR;
      }
      else {
        if (trackObject.sentToSmart) {
          fillcolor = [TP_COLOR_SMT[0], TP_COLOR_SMT[1], TP_COLOR_SMT[2], TP_OPACITY];
          color = TP_COLOR_SMT;
        } else {
          fillcolor = [TP_COLOR[0], TP_COLOR[1], TP_COLOR[2], TP_OPACITY];
          color = TP_COLOR;
        }
      }
    } else {
      fillcolor = [TP_COLOR[0], TP_COLOR[1], TP_COLOR[2], TP_OPACITY];
      color = TP_COLOR;
    }


    let added = false;
    if (threat && threat.polySet) {
      if (!this.drawData[TrackDataType.Threat]) {
        this.drawData[TrackDataType.Threat] = this.createGeometryDrawData(threat.poly, lineWidth, color, fillcolor);
        added = true;
      }

      if (update) {
        this.drawData[TrackDataType.Threat] = this.createGeometryDrawData(threat.poly, lineWidth, color, fillcolor);
      }

      if (added && this.isVisible()) {
        this.drawer.addObjectToDm(this, [TrackDataType.Threat], [TrackDataType.Threat]);
      }
    }
  }
}

